module.exports = __webpack_public_path__ + "img/block_4.f98a43be.png";